import { createSlice } from "@reduxjs/toolkit";

export const recuperacionesSlices = createSlice({
  name: "recuperaciones",
  initialState: {
    value: [],
  },
  reducers: {
    addList: (state, action) => {
      //
      state.value = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { addList } = recuperacionesSlices.actions;

export default recuperacionesSlices.reducer;
